import { mapGetters } from 'vuex';
import { cognitoMixins } from '@storm/mixins/cognito';

export default {
  computed: {
    ...mapGetters(['stormUsers', 'stormSession']),
  },
  mixins: [cognitoMixins],
  data() {
    return {
      loadingStormUsers: false,
      stormUsersError: false,
    };
  },
  methods: {
    async getStormUsers(refresh) {
      // this is used for assign ticket purposes
      if ((this.stormUsers.length < 1 && !refresh) || refresh) {
        this.loadingStormUsers = true;
        this.stormUsersError = false;
        try {
          const { data } = await this.stormInvoke({
            data: {
              method: 'getStormUsers',
            },
          });
          const { users } = data;
          this.$store.dispatch('setStormUsers', users);
        } catch (e) {
          const message = e.message || e;
          this.stormUsersError = message;
          this.$log.error(message);
        } finally {
          this.loadingStormUsers = false;
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/storm/mixins/load-data.js